import React from 'react';
import { withTd } from './hooks';

function Td({ Component }) {
  return <td className="p-2 rounded-sm text-sm text-zinc-800">{Component}</td>;
}

export default withTd(Td);
